import { on } from 'onyx-common/emitter'

export default on
